import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const ModelInfo = () => {
  const { product } = useProductDetail();

  if (!product?.manken_info?.details || product.manken_info.details.length === 0) {
    return null;
  }

  return (
    <div className="bg-gray-50 rounded-lg p-3 border shrink-0">
      <p className="text-sm text-muted-foreground text-center">
        {product.manken_info.details.map((detail, index) => (
          <span key={index}>
            {detail}
            {index < product.manken_info!.details.length - 1 && " | "}
          </span>
        ))}
      </p>
    </div>
  );
};

export default ModelInfo;
